(function () {
var $e710a76a00783ec1$exports = {};
const $e710a76a00783ec1$var$Configuration = {
    amplitudeApiKey: undefined,
    apiUrl: "https://api.hint.com",
    apiVersion: "20250506151636",
    emrNotesUrl: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com/prod",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com",
    emrCalendarsUrl: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com/prod",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com",
    env: "production",
    fullStoryOrgId: "o-1T3FAV-na1",
    googleMapsKey: `&key=${"AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4"}`,
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784027700",
    release: "7255c4f750613721ad9b27c309a77e2d676fe950",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "production",
    sentryReleaseVersion: "7255c4f750613721ad9b27c309a77e2d676fe950",
    stripePublishableKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    statuspageEmbedCode: "8mxj6zhmjmzp",
    rainforestEnv: "production"
};
$e710a76a00783ec1$exports = $e710a76a00783ec1$var$Configuration;


window.CONFIGURATION = $e710a76a00783ec1$exports;

})();
//# sourceMappingURL=member-portal-elm.6ecb3c9f.js.map
